
export const renewalOptionData = {
  chipCape: {
    name: "Chip Seal and Cape Seal",
    maxPCR: 80,
    minPCR: 40
  },
  thinHMA: {
    name: "Thin Hot Mix Asphalt Overlay",
    maxPCR: 65,
    minPCR: 30
  },
  fullDepth: {
    name: "Full Depth Reclamation",
    maxPCR: 50,
    minPCR: 0
  },
  fullRecon: {
    name: "Full Reconstruction",
    maxPCR: 50,
    minPCR: 0
  }
};

